import React from "react";
import "./Header.css";
import logo from "../Images/logo.png";

const Header = () => {
  return (
    <header className="d-flex align-items-center mt-5">
      <img src={logo} alt="" className="img-fluid logo me-2" />
      <p className="header fw-bold pt-3 fs-5">PROGRAMMING KNOWLEDGE CENTER</p>
    </header>
  );
};

export default Header;
